export const csvOptionsEnum = [
  {
    value: 'allBeneficiaries',
    label: 'Todos os beneficiários',
  },
  {
    value: 'filteredBeneficiaries',
    label: 'Resultados do filtro',
  },
  {
    value: 'selectedBeneficiaries',
    label: 'Selecionados',
  },
]
